import "./attendants.css";
import Navbar from "../../components/nav/Navbar";
import Footer from "../../components/Footer";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import Table from "../../components/Table";
import useAccount from "../../utils/useAccount";
import { useDispatch, useSelector } from "react-redux";
import Overlay from "../../components/Overlay";
import ResponsiveDialog from "../../components/Dialog";
import { ArrowDropDown, ArrowDropUp, Check, Close } from "@mui/icons-material";
import AttendantSalesDetails from "../../components/AttendantSalesDetails";
import { toggleAttendantsDetailsDialog } from "../../redux/GlobalStates";
import { useMemo } from "react";
const Attendants = () => {
  const store = useSelector((state) => state.store.Store);
  const allSales = useSelector((state) => state.sales.Sales);

  const {
    openDeleteDialog,
    openAttendantsDetailsDialog,
    collapseAttendantsForm,
  } = useSelector((state) => state.globalStates);
  const {
    newAttendant,
    setNewAttendant,
    addNewAttendant,
    attendantsColumn,
    editAttendant,
    handleEditAttendant,
    deleteAttendant,
    attendant,
    toggleDeleteDialog,
    toggleCollapseForm,
  } = useAccount();
  const dispatch = useDispatch();
  const transactions = useMemo(
    () => allSales.filter((sale) => sale.mode === attendant?.name),
    [attendant, allSales],
  );

  const attendant_performance_data = useMemo(
    () => ({
      added_at: transactions[0]?.createdAt,
      transactions: transactions.length,
      total_sales: transactions.reduce((a, b) => a + b.cost, 0),
      retail_sales: transactions
        .filter((sale) => sale.sale_type === "retail")
        .reduce((a, b) => a + b.cost, 0),
      wholesale_sales: transactions
        .filter((sale) => sale.sale_type === "wholesale")
        .reduce((a, b) => a + b.cost, 0),
      discounted_sales: transactions
        .filter((sale) => sale.sale_type === "agreed price")
        .reduce((a, b) => a + b.cost, 0),
      cash: transactions
        .filter((sale) => sale.payment_method === "Cash")
        .reduce((a, b) => a + b.cost, 0),
      momo: transactions
        .filter((sale) => sale.payment_method === "Mobile Money")
        .reduce((a, b) => a + b.cost, 0),
      bank: transactions
        .filter((sale) => sale.payment_method === "Bank")
        .reduce((a, b) => a + b.cost, 0),
      credit: transactions
        .filter((sale) => sale.payment_method === "Credit")
        .reduce((a, b) => a + b.cost, 0),
    }),
    [transactions],
  );
  return (
    <>
      <AttendantSalesDetails
        open={openAttendantsDetailsDialog}
        attendant={attendant}
        handleClose={() => dispatch(toggleAttendantsDetailsDialog())}
        data={attendant_performance_data}
      />
      <Navbar />
      {store.mode !== "Admin" && <Overlay />}
      <ResponsiveDialog
        open={openDeleteDialog}
        title={`Delete ${attendant?.name}!`}
        DialContent={`This operation would delete ${attendant?.name} from your attendants' list. Would you like to proceed?`}
        option1={<Close className="close red" />}
        option2={<Check />}
        handleClose={toggleDeleteDialog}
        event={() => deleteAttendant(attendant?.id)}
      />
      <div className="attendants-main-container">
        <div className="attendants-left">
          <div className="add-new-attendant-form">
            <div className="attendants-form-heading-container">
              <h1 className="heading">Add new Attendant</h1>
              {!collapseAttendantsForm && (
                <Tooltip title="Collapse form" placement="top">
                  <ArrowDropDown
                    className="collapse-icon"
                    onClick={toggleCollapseForm}
                  />
                </Tooltip>
              )}
              {collapseAttendantsForm && (
                <Tooltip title="Expand form" placement="top">
                  <ArrowDropUp
                    className="collapse-icon"
                    onClick={toggleCollapseForm}
                  />
                </Tooltip>
              )}
            </div>
            {!collapseAttendantsForm && (
              <>
                <Tooltip
                  title="Attendant's Username must be unique"
                  placement="top"
                >
                  <TextField
                    margin="dense"
                    label="Username"
                    type="text"
                    fullWidth
                    variant="outlined"
                    className="dial-input"
                    value={newAttendant?.name || ""}
                    onChange={(e) =>
                      setNewAttendant((prev) => ({
                        ...prev,
                        name: e.target.value,
                        id: Math.round(Math.random() * 99999).toString(),
                      }))
                    }
                  />
                </Tooltip>
                <Tooltip
                  title="Password must be at least 6 characters long"
                  placement="top"
                >
                  <TextField
                    margin="dense"
                    label="Password"
                    type="password"
                    fullWidth
                    variant="outlined"
                    className="dial-input"
                    value={newAttendant?.password || ""}
                    onChange={(e) =>
                      setNewAttendant((prev) => ({
                        ...prev,
                        password: e.target.value,
                      }))
                    }
                  />
                </Tooltip>
                <h1 className="heading">Roles and privileges</h1>
                <Tooltip
                  title="If set to yes, the attendant will be able to sell items."
                  placement="top"
                >
                  <FormControl fullWidth margin="dense">
                    <InputLabel id="demo-controlled-open-select-label">
                      Sell Item
                    </InputLabel>
                    <Select
                      label="Offer Discount"
                      fullWidth
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      value={newAttendant.sell_item}
                      onChange={(e) =>
                        setNewAttendant((prev) => ({
                          ...prev,
                          sell_item: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
                <Tooltip
                  title="If set to yes, the attendant will be able to sell items at an agreed price. This means that the attendant can offer discounts on items during checkout."
                  placement="top"
                >
                  <FormControl fullWidth margin="dense">
                    <InputLabel id="demo-controlled-open-select-label">
                      Offer Discount
                    </InputLabel>
                    <Select
                      label="Offer Discount"
                      fullWidth
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      value={newAttendant.offer_discount}
                      onChange={(e) =>
                        setNewAttendant((prev) => ({
                          ...prev,
                          offer_discount: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
                <Tooltip
                  title="If set to yes, the attendant will be able to add new items to the inventory."
                  placement="top"
                >
                  <FormControl fullWidth margin="dense">
                    <InputLabel id="demo-controlled-open-select-label">
                      Add Item
                    </InputLabel>
                    <Select
                      label="Offer Discount"
                      fullWidth
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      value={newAttendant.add_item}
                      onChange={(e) =>
                        setNewAttendant((prev) => ({
                          ...prev,
                          add_item: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
                <Tooltip
                  title="If set to yes, the attendant will be able to edit existing items in the inventory - e.g. price, quantity, etc."
                  placement="top"
                >
                  <FormControl fullWidth margin="dense">
                    <InputLabel id="demo-controlled-open-select-label">
                      Edit Item
                    </InputLabel>
                    <Select
                      label="Offer Discount"
                      fullWidth
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      value={newAttendant.edit_item}
                      onChange={(e) =>
                        setNewAttendant((prev) => ({
                          ...prev,
                          edit_item: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
                <Tooltip
                  title="If set to yes, the attendant will be able to delete items from the inventory. "
                  placement="top"
                >
                  <FormControl fullWidth margin="dense">
                    <InputLabel id="demo-controlled-open-select-label">
                      Delete Item
                    </InputLabel>
                    <Select
                      label="Offer Discount"
                      fullWidth
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      value={newAttendant.delete_item}
                      onChange={(e) =>
                        setNewAttendant((prev) => ({
                          ...prev,
                          delete_item: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
                <Tooltip
                  title="If set to yes, the attendant will be able to restock items in the inventory."
                  placement="top"
                >
                  <FormControl fullWidth margin="dense">
                    <InputLabel id="demo-controlled-open-select-label">
                      Restock Items
                    </InputLabel>
                    <Select
                      label="Offer Discount"
                      fullWidth
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      value={newAttendant.restock_item}
                      onChange={(e) =>
                        setNewAttendant((prev) => ({
                          ...prev,
                          restock_item: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
                <Tooltip
                  title="If set to yes, the attendant will be able to view the store summary - i.e. total sales, total transactions, total profit, inventory values etc."
                  placement="top"
                >
                  <FormControl fullWidth margin="dense">
                    <InputLabel id="demo-controlled-open-select-label">
                      View store summary
                    </InputLabel>
                    <Select
                      label="Offer Discount"
                      fullWidth
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      value={newAttendant.view_store_summary}
                      onChange={(e) =>
                        setNewAttendant((prev) => ({
                          ...prev,
                          view_store_summary: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
                <Tooltip
                  title="If set to yes, the attendant will be able to view detailed sales information, such as monthly sales reports, sales made by other attendants, best selling items, etc. "
                  placement="top"
                >
                  <FormControl fullWidth margin="dense">
                    <InputLabel id="demo-controlled-open-select-label">
                      View Sales Details
                    </InputLabel>
                    <Select
                      label="Offer Discount"
                      fullWidth
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      value={newAttendant.see_sales_details}
                      onChange={(e) =>
                        setNewAttendant((prev) => ({
                          ...prev,
                          see_sales_details: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
                <Tooltip
                  title="If set to yes, the attendant will be able to manage expenses - i.e. add, edit and delete expenses. "
                  placement="top"
                >
                  <FormControl fullWidth margin="dense">
                    <InputLabel id="demo-controlled-open-select-label">
                      Manage Expenses
                    </InputLabel>
                    <Select
                      label="Offer Discount"
                      fullWidth
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      value={newAttendant.see_sales_details}
                      onChange={(e) =>
                        setNewAttendant((prev) => ({
                          ...prev,
                          manage_expenses: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
                <Tooltip
                  title="If set to yes, the attendant will be able to manage credit - i.e. add, edit and delete credit entries."
                  placement="top"
                >
                  <FormControl fullWidth margin="dense">
                    <InputLabel id="demo-controlled-open-select-label">
                      Manage Credit
                    </InputLabel>
                    <Select
                      label="Offer Discount"
                      fullWidth
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      value={newAttendant.see_sales_details}
                      onChange={(e) =>
                        setNewAttendant((prev) => ({
                          ...prev,
                          manage_credit: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Tooltip>
                {store.mode === "Admin" && (
                  <button
                    disabled={store.mode !== "Admin"}
                    className="add-new-btn"
                    onClick={
                      editAttendant ? handleEditAttendant : addNewAttendant
                    }
                  >
                    {editAttendant ? "Edit" : "Add"}
                  </button>
                )}
              </>
            )}
          </div>
        </div>
        <div className="attendants-right">
          <h1 className="heading">Attendants</h1>
          <div className="attendants-container">
            <Table columns={attendantsColumn} rows={store?.attendants} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Attendants;
